import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import useTransactions from "../../../../hooks/useTransactions";
import localeText from "../../../../locale";
import { formatDate } from "../../../../utilities/formatDate";
import "../UserDashboardHome/UserDashboardHome.css";
import "./StatementTable.css";
import { formatFloatToInteger } from "../../../../utilities/formatFloatToInteger";
import { formatPrice } from "../../../../utilities/formatPrice";

const StatementTable = (props) => {
  const {
    dateBegin,
    dateEnd,
    getTransactionTable,
    loading,
    setDateBegin,
    setDateEnd,
    statementData,
    routeName,
  } = useTransactions();

  return (
    <div>
      <div className="card border-1 border-300">
        {props.plan !== "Manager" &&
        props.plan !== "Partner" &&
        props.plan !== "Seller" &&
        props.bonus &&
        routeName !== "extrabonusStatement" ? (
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        ) : (
          <>
            <h3 className="my-4">{localeText(routeName)}</h3>
            <hr />

            <div className="mb-4 lg:flex md:flex lg:align-items-center md:align-items-center lg:flex-wrap md:flex-wrap">
              <ul className="list-none p-0 m-0">
                <li>
                  <label htmlFor="dateBegin">{localeText("from")}</label>
                </li>
                <li>
                  <Calendar
                    name="dateBegin"
                    className="mt-2 mr-2 w-full lg:w-auto md:w-auto"
                    value={dateBegin}
                    onChange={(e) => setDateBegin(e.value)}
                    dateFormat="dd/mm/yy"
                  />
                </li>
              </ul>
              <ul className="list-none p-0">
                <li>
                  <label htmlFor="dateEnd">{localeText("toFrom")}</label>
                </li>
                <li>
                  <Calendar
                    className="mt-2 w-full lg:w-auto md:w-auto"
                    dateFormat="dd/mm/yy"
                    name="dateEnd"
                    value={dateEnd}
                    onChange={(e) => setDateEnd(e.value)}
                  />
                </li>
              </ul>
              <div className="lg:text-left md:text-left text-center button-check-statement">
                <Button
                  className="lg:ml-2 md:ml-2 ml-0"
                  label={localeText("check")}
                  onClick={() => getTransactionTable(dateBegin, dateEnd)}
                  loading={loading}
                />
              </div>
            </div>
            <DataTable
              value={statementData}
              paginator
              responsiveLayout="scroll"
              loading={loading}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
            >
              <Column
                header={localeText("date")}
                body={(rowData) => {
                  return <>{rowData.date && <div>{formatDate(rowData.date)}</div>}</>;
                }}
              ></Column>
              <Column field="description" header={localeText("description")}></Column>
              <Column
                header={localeText("inbound")}
                body={(rowData) => {
                  const inboundValue = props.bonus ? rowData.income : rowData.income;

                  return props.onlyIntegerValues
                    ? formatFloatToInteger(inboundValue)
                    : `${props.currency} ${formatPrice(inboundValue)}`;
                }}
              ></Column>
              <Column
                header={localeText("outbound")}
                body={(rowData) => {
                  const outboundValue = props.bonus ? rowData.outcome : rowData.outcome;

                  return props.onlyIntegerValues
                    ? formatFloatToInteger(outboundValue)
                    : `${props.currency} ${formatPrice(outboundValue)}`;
                }}
              ></Column>
              <Column
                header={localeText("status")}
                body={(rowData) => {
                  const rowContent = {
                    COMPLETED: {
                      text: "completed",
                      color: "#46a748",
                    },
                    PENDING: {
                      text: "pending",
                      color: "#F7B005",
                    },
                    PENDINGVOUCHER: { text: "pendingVoucher", color: "#F7B005" },
                    CANCELED: { text: "canceled", color: "#eb4034" },
                  };

                  const rowContentObj = rowContent[rowData.status] ?? null;

                  return (
                    <>
                      {rowContentObj && (
                        <span
                          className="team-member-role text-0 p-1 border-round"
                          style={{ backgroundColor: rowContentObj.color }}
                        >
                          {localeText(rowContentObj.text)}
                        </span>
                      )}
                    </>
                  );
                }}
              ></Column>
            </DataTable>
          </>
        )}
      </div>
    </div>
  );
};

export default StatementTable;
